import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { orderBy } from "lodash";

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const dictionaryCalendar = await dictionariesService.getDictionary({
    id: 'calendar-origin',
    parameters: {},
  });
  const calendarItems = await dictionaryCalendar.getAll();
  const [countLastWeeks, weekFrequency] = [503, 7];
  const limitYear = new Date().getFullYear();
  const sordetItems = orderBy(calendarItems, item => Number(item.id));
  const weeks = sordetItems.filter(item => {
    const isWeek = weekFrequency === item.getValue<number>('frequencyId');
    const yearWeek = Number(item.id.slice(1, 5));
    return isWeek && yearWeek <= limitYear;
  });
  const selectedWeeks = weeks.reverse().slice(0, countLastWeeks).reverse();

  return {
    calendar: selectedWeeks.map(item => Number(item.id)),
    calendarDisplay: selectedWeeks.map(item => Number(item.id)),
  };
}